import { createRoot } from 'react-dom/client'
import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material'
import { lazy, Suspense } from 'react'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { isMarketingPath } from './marketing/routes'
import { hasOAuthHashSession } from './lib/api/auth'
import './index.css'
import { muiTheme } from './theme/muiTheme'
import { registerDynamicImportRecovery } from './utils/dynamic-import-recovery'
import { bootstrapDemoMode } from './demo/config'

const MarketingApp = lazy(() => import('./marketing/MarketingApp'))
const App = lazy(async () => {
  const { installDemoFetchMock } = await import('./demo/mockApi')
  installDemoFetchMock()
  return import('./App')
})
function SiteEntry() {
  const { pathname } = useLocation()
  // A trailing splat owns every nested path, e.g. /clients/:id/details-v2/overview.
  const appRoute = __APP_ROUTE_PATTERNS__.some(route => {
    const pattern = route.replace(/:[^/]+/g, '[^/]+').replace(/\/\*$/, '(?:/.*)?')
    return new RegExp('^' + pattern + '$').test(pathname)
  })
  const marketing = (isMarketingPath(pathname) || !appRoute) && !hasOAuthHashSession()
  return <Suspense fallback={null}>{marketing ? <MarketingApp /> : <App />}</Suspense>
}

registerDynamicImportRecovery()
bootstrapDemoMode()
createRoot(document.getElementById("root")!).render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <SiteEntry />
      </BrowserRouter>
    </ThemeProvider>
  </StyledEngineProvider>
);
